import React, {Fragment, useState} from 'react';
import {Button, Nav, NavDropdown, Navbar} from 'react-bootstrap';
import {LinkContainer} from 'react-router-bootstrap';
import ScrollLock, {TouchScrollable} from 'react-scrolllock';

import {InternalApps} from './components/AppDropdowns';

import {faBookmark, faCog, faGripHorizontal} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import styles from './css/Header.module.scss';
import {domains} from './domains';

const handleLoginRedirect = (event, link, newTab) => {
	event.preventDefault();
	const url = `${domains.apiDomain}/redirect-me/` + encodeURIComponent(link);
	if (newTab) {
		window.open(url, '_blank');
	} else {
		window.location.href = url;
	}
};

const Header = props => {
	const tabs = props.tabs || [];
	const {
		initialAuthChecked,
		hasFV3Access,
		loginButtonClicked,
		isLoggedIn,
		showInternal,
		globalIntelligenceDomain
	} = props;
	const [expanded, setExpanded] = useState(false);

	let middleContent = null;
	let rightContent = null;
	let internalIcon = null;

	if (!isLoggedIn && initialAuthChecked) {
		// Not logged in
		rightContent = (
			<Nav>
				<Button title="Login" className={styles.logout} variant="link" onClick={loginButtonClicked}>
					LOGIN
				</Button>
			</Nav>
		);
	} else if (!hasFV3Access) {
		// Logged in free users
		rightContent = (
			<LinkContainer title="Logout" exact to="/logout">
				<Nav.Link>LOGOUT</Nav.Link>
			</LinkContainer>
		);
	} else {
		// logged in paid users
		if (showInternal) {
			internalIcon = (
				<NavDropdown
					variant="outline"
					alignRight
					name="Internal Apps"
					title={
						<React.Fragment>
							<FontAwesomeIcon title="Access Internal apps" className="d-none d-md-block" icon={faGripHorizontal} />
							<span className="d-md-none">INTERNAL APPS</span>
						</React.Fragment>
					}
				>
					<InternalApps onClick={handleLoginRedirect} />
				</NavDropdown>
			);
		}
		middleContent = (
			<Fragment>
				{tabs}
				<Nav.Link
					href={`${domains.legacyFvDomain}/#dx`}
					onClick={event => handleLoginRedirect(event, `${domains.legacyFvDomain}/#dx`)}
					title="Data"
					className={styles.navItem}
				>
					DATA
				</Nav.Link>
				<Nav.Link
					href={`${domains.legacyFvDomain}/#dashboards`}
					onClick={event => handleLoginRedirect(event, `${domains.legacyFvDomain}/#dashboards`)}
					title="Dashboards"
					className={styles.navItem}
				>
					DASHBOARDS
				</Nav.Link>
			</Fragment>
		);
		rightContent = (
			<Fragment>
				<LinkContainer title="Favorites" exact to="/favorites">
					<Nav.Link>
						<FontAwesomeIcon title="Access bookmarked content" className="d-none d-md-block" icon={faBookmark} />
						<span className="d-md-none">FAVORITES</span>
					</Nav.Link>
				</LinkContainer>
				<NavDropdown
					alignRight
					name="Settings"
					title={
						<React.Fragment>
							<FontAwesomeIcon title="Settings" className="d-none d-md-block pull-right" icon={faCog} />
							<span className="d-md-none">SETTINGS</span>
						</React.Fragment>
					}
				>
					<LinkContainer title="Settings" exact to="/settings">
						<NavDropdown.Item className="nav-item-no-active">Settings</NavDropdown.Item>
					</LinkContainer>
					<LinkContainer title="Terms of Service" exact to="/termsOfService">
						<NavDropdown.Item className="nav-item-no-active">Terms of Service</NavDropdown.Item>
					</LinkContainer>
					<LinkContainer title="Logout" exact to="/logout">
						<NavDropdown.Item className="nav-item-no-active">Logout</NavDropdown.Item>
					</LinkContainer>
				</NavDropdown>
			</Fragment>
		);
	}

	return (
		<Navbar
			collapseOnSelect
			bg="primary"
			variant="dark"
			expand={hasFV3Access ? 'md' : true}
			fixed="top"
			onToggle={tog => setExpanded(tog)}
			className={[styles.navMain, isLoggedIn ? '' : styles.navMainLoggedOut]}
		>
			<ScrollLock isActive={expanded} />
			<Navbar.Toggle aria-controls="navvynav-collapse" />
			<TouchScrollable>
				<Navbar.Collapse id="navvynav-collapse" className={`${expanded ? 'overflow-auto max-100vh' : null}`}>
					<Nav className="mr-auto">
						<Fragment>
							<div
								className="d-none d-md-flex"
								style={{
									display: 'flex',
									alginItems: 'center',
									flexDirection: 'column',
									justifyContent: 'center',
									paddingRight: '.5rem'
								}}
							>
								<LinkContainer title="Home" exact to="/" style={{paddingTop: 0, paddingBottom: 0}}>
									<Nav.Link>
										<img
											alt="FrontierView"
											title="FrontierView"
											src="https://s3.amazonaws.com/images.frontierview.com/fv3/fv-logo.png"
											width="215"
										/>
									</Nav.Link>
								</LinkContainer>
								<a
									href={globalIntelligenceDomain}
									style={{color: 'white', lineHeight: 1.846, paddingLeft: '2px'}}
									target="_blank"
								>
									Explore FiscalNote Global Intelligence
								</a>
							</div>
							<LinkContainer className="d-md-none" title="Home" exact to="/">
								<Nav.Link>
									<img
										alt="FrontierView"
										title="FrontierView"
										src="https://s3.amazonaws.com/images.frontierview.com/fv3/fv-fn-logo.png"
										width="220"
									/>
								</Nav.Link>
							</LinkContainer>
							{middleContent}
						</Fragment>
					</Nav>
					<Nav className={styles.iconLinks + ' d-md-flex d-block'}>
						{internalIcon}
						{rightContent}
					</Nav>
				</Navbar.Collapse>
			</TouchScrollable>
		</Navbar>
	);
};

export default Header;
